<app-modal-frame
  [headerText]="CONSTS.HEADER"
  [rightButton]="{
    disable: outstandingReportForm.invalid,
    type: BUTTON_TYPES.REPORT_BUTTON,
  }"
  (emitExit)="clickExit()"
  (emitRightClick)="getReport()"
>
  <form class="collected-container" [formGroup]="outstandingReportForm">
    <app-from-to-date
      [fromControl]="'fromDate'"
      [toControl]="'toDate'"
      [customMaxToDate]="customMaxDate"
      [customMaxFromDate]="customMaxDate"
      [formGroupValue]="outstandingReportForm"
    ></app-from-to-date>

    <!-- Report Format -->
    <ion-row>
      <ion-col>
        <app-report-format
          [radioButtonValue]="outstandingReportForm.get('reportFormat')?.value"
          (emitRadioChange)="radioChange($event)"
        ></app-report-format>
      </ion-col>
    </ion-row>

    <!-- Note -->
    <ion-row>
      <ion-col>
        <app-download-note numRows="2,000"></app-download-note>
      </ion-col>
    </ion-row>
  </form>
</app-modal-frame>

<app-pdf-report-generator
  #pdfContainer
  [hidden]="true"
  [columns]="PDF_REPORT.COLUMNS"
  [columnsData]="
    outstandingReportResponse &&
    outstandingReportResponse.response.CODCollectedCleared
  "
  [dataFields]="PDF_REPORT.DATA_FIELDS"
  [hasSingleSubHeaderView]="false"
  [columnDataFontSize]="'10px'"
  [columnWidths]="[85, 50, 125, 115, 130, 80, 65, 50, 80, 85, 80, 90]"
>
  @if (outstandingReportResponse && outstandingReportResponse.response) {
    <ng-container sub-header>
      <table
        aria-hidden="true"
        class="pdf-sub-header-table"
      >
        <tr class="pdf-sub-header-row">
          <td>
            {{ PDF_REPORT.HEADER.LOCATION }}
            {{ outstandingReportResponse.response.location }}
          </td>
          <td>
            {{ PDF_REPORT.HEADER.TURN_IN }}
            {{ outstandingReportResponse.response.turninDate }}
          </td>
        </tr>
      </table>
    </ng-container>
  }
  @if (outstandingReportResponse && outstandingReportResponse.response) {
    <ng-container total>
      <table
        aria-hidden="true"
        class="pdf-total-table"
      >
        <tr class="pdf-total-row">
          <td class="pdf-total-cell">
            {{ PDF_REPORT.FOOTER.TOTAL_EXPECTED }}
            {{ outstandingReportResponse.response.TotalExpectedCOD }}
          </td>
          <td class="pdf-total-cell">
            {{ PDF_REPORT.FOOTER.TURNED_IN }}
            {{ outstandingReportResponse.response.TotalTurnedInCOD }}
          </td>
        </tr>
      </table>
    </ng-container>
  }
</app-pdf-report-generator>
